import React, { useState, useRef  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    Button,
    Col,
    Container,
    Input,
    Label,
    Row,
    Table
} from "reactstrap";
import {
    removeCartItem,
    updateCartItemQuantity,
} from "../../store/reducer/productReducer";
import Pageheading from "../../widgets/PageHeading";
import Header2 from '../../Layout/Header/Header2';
import Modal from 'react-modal';

function Invoice() {
    const cartItems = useSelector((state) => state.products.cart);
    const [productItems, setProductItems] = useState([
        { id: 1, name: 'Item', salePrice: 0, quantity: 1, periode: '23 May 2025 - 6 April 2025', status: 'paid' },
        { id: 2, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 April 2025 - 6 May 2025', status: 'paid' },
        { id: 3, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 May 2025 - 6 June 2025', status: 'paid' },
        { id: 4, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 June 2025 - 6 July 2025', status: 'unpaid' },
        { id: 5, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 July 2025 - 6 August 2025', status: 'unpaid' },
        { id: 6, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 August 2025 - 6 September 2025', status: 'unpaid' },
        // { id: 7, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 September 2025 - 6 October 2025', status: 'unpaid' },
        // { id: 8, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 October 2025 - 6 November 2025', status: 'unpaid' },
        // { id: 9, name: 'Item', salePrice: 220000, quantity: 1, periode: '7 November 2025 - 6 December 2025', status: 'unpaid' }
      ]);
    
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    
    const [quantities, setQuantities] = useState(
        productItems.map((item) => item.quantity)
    );
    
    const calculateTotal = () => {
        return productItems.reduce((total, item) => {
            const itemTotal = item.status == "unpaid" ? item.quantity * item.salePrice : 0;
            return total + itemTotal;
        }, 0);
    };

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const [isCopied, setIsCopied] = useState(false);
    const timeoutId = useRef(null);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText("218401000569565");
            setIsCopied(true);

            clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
            setIsCopied(false);
        }
      };
    
    let Tax = 1.0;
    return (
        <div className="page-wrapper">
            <Header2 />
            <section className="position-relative">
                <Pageheading foldername={"Shop"} title={"Invoice"} />
            </section>
            <div className="page-content">
                <section>
                    <Container>
                        <Row>
                            <Col>
                                <div className="table-responsive ">
                                    <Table className="cart-table table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="bg-primary text-white" scope="col">
                                                    Product
                                                </th>
                                                <th className="bg-primary text-white" scope="col">
                                                    Periode
                                                </th>
                                                <th className="bg-primary text-white" scope="col">
                                                    Quantity
                                                </th>
                                                <th className="bg-primary text-white" scope="col">
                                                    Total
                                                </th>
                                                <th className="bg-primary text-white" scope="col">
                                                    Status
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody className="border-top-0">
                                            {productItems.map((item, index) => (
                                                <tr key={index}>
                                                    {index == 0 ? 
                                                        <td rowspan={productItems.length}>
                                                            {/*<Link to="/">
                                                                <img
                                                                    className="img-fluid me-lg-2 mb-2 mb-lg-0"
                                                                    style={{ height: "100px", width: "100px" }}
                                                                    src={require(`../../assets/images/${item.pictures[0]}`)}

                                                                    alt={item.name}
                                                                />
                                                            </Link>*/}
                                                            <h6 className="mb-0 text-start">
                                                                <b>VPS-SISKOE</b>
                                                                <ul>
                                                                    <li>Express Linux VPS</li>
                                                                    <li>2 CPU Cores</li>
                                                                    <li>4GB RAM</li>
                                                                    <li>60 GB SSD Disk</li>
                                                                    <li>100Mbps Unmetered Bandwidth</li>
                                                                    <li>Once per 4 Weeks Backup</li>
                                                                    <li>1 Dedicated IPv4</li>
                                                                    <li>Operating System(CentOS 7.x 64-bit) </li>
                                                                </ul>
                                                            </h6>
                                                        </td> : <></>
                                                    }
                                                    <td>
                                                        <h6 className="mb-0">{item.periode}</h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="mb-0">{item.quantity}</h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="mb-0">
                                                            IDR {numberWithCommas(item.quantity * item.salePrice)}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <div className={item.status == "paid" ? "badge-primary-soft rounded p-0" : "badge-danger-soft rounded p-0"}>
                                                            {item.status.toUpperCase()}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-8">
                            <div class="col-lg-12 pe-5 mt-5 mt-lg-0">
                                <div class="row justify-content-end">
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-md-12 text-start border-bottom mb-5">
                                                <h3 class="text-dark h4 text-uppercase">Recipients</h3>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <span class="text-dark">Beneficiary</span>
                                            </div>
                                            <div class="col-md-6 text-end">
                                                <strong class="text-dark">PT. Akar Tumbuh Buah</strong>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <span class="text-dark">Bank Account</span>
                                            </div>
                                            <div class="col-md-6 text-end">
                                                <strong class="text-dark">Bank Rakyat Indonesia</strong>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <span class="text-dark">Bank Number</span>
                                            </div>
                                            <div class="col-md-6 text-end">
                                                <strong class="text-dark">2184-01-000569-56-5</strong>
                                                <Link
                                                    className="wishlist-btn p-1"
                                                    onClick={handleCopy}
                                                >
                                                    <i className="ti-link"></i>
                                                </Link>
                                                {isCopied && (
                                                    <div
                                                      style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                        color: 'white',
                                                        padding: '10px 20px',
                                                        borderRadius: '5px',
                                                        fontSize: '0.8em',
                                                        zIndex: 1,
                                                      }}
                                                    >
                                                      Copied to clipboard!
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div class="row mb-5">
                                            <div class="col-md-6">
                                                <span class="text-dark">Swift Code</span>
                                            </div>
                                            <div class="col-md-6 text-end">
                                                <strong class="text-dark">BRINIDJA</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                    </div>
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-md-12 text-end border-bottom mb-5">
                                                <h3 class="text-dark h4 text-uppercase">Cart Totals</h3>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <span class="text-dark">Subtotal</span>
                                            </div>
                                            <div class="col-md-6 text-end">
                                                <strong class="text-dark">IDR {numberWithCommas(calculateTotal())}</strong>
                                            </div>
                                        </div>
                                        <div class="row mb-5">
                                            <div class="col-md-6">
                                                <span class="text-dark">Total</span>
                                            </div>
                                            <div class="col-md-6 text-end">
                                                <strong class="text-dark">IDR {numberWithCommas(calculateTotal())}</strong>
                                            </div>
                                        </div>
                                        {/*<div class="row">
                                            <div class="col-12">
                                                <Link className="btn btn-primary btn-md btn-block mb-2" onClick={openModal}>
                                                    Proceed To Payment
                                                </Link>
                                            </div>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        </Row>
                        {isOpen && <Modal
                            isOpen={isOpen}
                            onRequestClose={closeModal}
                            appElement={document.getElementById('root')}
                            style={{
                                overlay: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    zIndex: 9999,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                },
                                content: {
                                    position: 'relative',
                                    border: 'none',
                                    background: 'none',
                                    padding: 0,
                                    width: '50%',
                                    maxHeight: '50%',
                                    marginTop: '5rem',
                                },
                            }}
                        >

                            <div
                                style={{
                                    position: 'relative',
                                    paddingBottom: '56.25%',
                                    height: 0,
                                    maxWidth: '100%',
                                    backgroundColor: 'white'
                                }}
                            >
                                <div className="page-content">
                                    <h2 className="p-4 text-center"><b>Payment Method</b></h2>
                                    <section>
                                    </section>
                                </div>
                            </div>
                        </Modal>}
                    </Container>
                </section>
            </div>
        </div >
    );
}

export default Invoice;
